(function() {
	"use strict"

	angular.module( "ATMGurus" )

	.controller("StoreController", [
		"Api.Store",
		"$scope",
		"User",
		"FilterService",
		"$location",
		"$state",
		"Loader",
		"$rootScope",
		function(Store, $scope, User, FilterService, $location, $state, Loader, $rootScope) {

			var _this = this;

			// products or services?
			this.type = Store.getContext().filterName;
			this.Store = Store;

			this.filters = FilterService.filters[ this.type ]
			this.search = $location.search();

			// update url with current filters
			// FilterService.getFromUrl( this.type )
			FilterService.setToUrl( this.type )

			$scope.$on('$stateChangeStart', (evt, toState, toParams, fromState, fromParams) => {
				if ( /products/.test(toState.name) || /repairs/.test(toState.name) ) {
					var context = Store.switchContext(toState.name);
					this.update();
				}
			})

			/**-----------------------------------------------------------------------------------
			*
			*		Update products and categories
			*	update filters using controller's ( this.filters )
			*
			---------------------------------------------------------------------------------------*/
			this.update = function(skip_categories, skip_pagination) {
				// CWI order => no cache
				var forceReload = false
				this.type = Store.getContext().filterName;
				this.filters = FilterService.filters[this.type]
				Store.getProducts(this.filters, forceReload);
				if (this.filters.where.sell_condition === 'CWI') {
					forceReload = true
				}
				if (!skip_pagination) { // until we put in place a front-end handling of the pagination, we shouldn't skip this.
					Store.getPagination(this.filters, forceReload);
				};
				if (!skip_categories) {
					Store.getCategories(this.filters, forceReload);
				};
				FilterService.setToUrl(this.type, forceReload);
			}
			this.isFiltered = function() {
				return Object.keys( this.filters.where ).length;
			}

			this.takeOptions = [
				{ key: 12, value: "12 per page" },
				{ key: 25, value:  "25 per page" },
				{ key: 50, value: "50 per page" },
				{ key: 100, value: "100 per page" },
				{ key: 200, value: "200 per page" }
			]

			this.sortBy = [
				{ key: "price", value: "Price" },
				{ key: "title", value: "Title" },
			]

			this.sortOrder  = [
				{ key: "DESC", value: "Descending"},
				{ key: "ASC", value: "Ascending"},
			]

			this.currentSortKey = Object.keys(this.filters.orderBy)[0];
			this.orderDirection = this.filters.orderBy[this.currentSortKey];

			this.toggleDirection = function() {
				this.orderDirection = this.orderDirection === "ASC" ?  "DESC" :  "ASC";
			}

			/**------------------------------------------------------------------
			*
			*	Filtering
			*
			------------------------------------------------------------------*/
			this.filterCategory = function( categoryName, detail ) {

				delete $location.search()['search'];
				FilterService.textSearch.searchString.text = "";

				FilterService.filters[ _this.type ].page = 1;
				FilterService.filters[ _this.type ].search = '';
				FilterService.filters[ _this.type ].where[ categoryName ] = detail;
				_this.update();
			}

			$scope.$watchGroup( ["StoreCtrl.currentSortKey", "StoreCtrl.orderDirection"], function( nv, ov )  {
				if ( !angular.equals( nv, ov ) ) {
					_this.filters.orderBy = {};
					_this.filters.orderBy[ nv[0] ] = _this.orderDirection;
					$location.search( "sortby", _this.currentSortKey )
					$location.search( "sortorder", _this.orderDirection )
					_this.update();
				}
			} )

			/**------------------------------------------------------------------
			*
			* 	Pagination
			*
			------------------------------------------------------------------*/
			$scope.$watch( "StoreCtrl.filters.page", function( nv, ov ) {
				if ( nv !== ov ) {
					$location.search( "page", _this.filters.page )
					_this.update(true);
				}
			})

			$scope.$watch( "StoreCtrl.filters.take", function( nv, ov ) {
				if ( nv !== ov ) {
					$location.search( "take", _this.filters.take )
					_this.filters.page = 1;
					_this.update(true);
				}
			})

			this.turnPage = function( incr ) {
				_this.filters.page = parseInt( this.filters.page ) + incr ;
				$location.search( "page", _this.filters.page )
				_this.update(true);
 			}

 			this.goToPage = function( page ) {
				this.filters.page = page ;
				$location.search( "page", _this.filters.page )
				_this.update(true);
 			}

			/**------------------------------------------------------------------
			*
			*   Clearing Filters
			*
			------------------------------------------------------------------*/
			this.clearFilter = function(category) {
		        var category_suffix = "_detail";
				_this.filters.page = 1;
				if ( !_.isUndefined(category) ) {
					delete _this.filters.where[category];
					_.forEach(Store.categories(), function(current_category) {
			            if (current_category.category_type === category + category_suffix) {
							delete _this.filters.where[current_category.category_type];
			            }
		          })
				} else {
					_this.filters.where = {};
				}
				_this.update();
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/controllers/StoreController.js